import React, { createContext, useCallback, useContext, useState } from "react";
import { NavLink } from "react-router-dom";
import { OriginScope, OriginSummary } from "../../lib/origin.jsx";
import { subnavFor } from "../../lib/forecastApi";
import { useRole } from "../../lib/role.jsx";
import { SectionHeader } from "../Primitives";
import { cn } from "../../lib/utils";
import DrillDrawer from "./DrillDrawer";

const DrillCtx = createContext({ open: () => {} });
export const useDrill = () => useContext(DrillCtx);

function Tabs() {
  const { role } = useRole();
  return (
    <nav data-testid="fc-subnav" className="flex gap-1 overflow-x-auto -mx-1 px-1 pb-1 border-b border-border">
      {subnavFor(role?.id).map(t => (
        <NavLink key={t.to} to={t.to} end={t.end} data-testid={`fc-tab-${t.id}`}
                 className={({ isActive }) => cn("shrink-0 px-3 py-2 text-[12.5px] border-b-2 -mb-[5px] transition-colors whitespace-nowrap",
                   isActive ? "border-primary text-primary font-medium" : "border-transparent text-muted hover:text-fg")}>
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}

// Drill-down drawer for forecast lines used outside the module (Command Center, Inventory Intelligence).
export function DrillScope({ children }) {
  const [lineId, setLineId] = useState(null);
  const open = useCallback((id) => setLineId(id), []);
  return (
    <DrillCtx.Provider value={{ open }}>
      {children}
      {lineId && <DrillDrawer key={lineId} lineId={lineId} onClose={() => setLineId(null)} />}
    </DrillCtx.Provider>
  );
}

// Shared frame for every Forecast / Prediction Models page: header, sub-navigation, origin summary and the drill-down drawer.
export default function ForecastLayout({ eyebrow, title, description, action, children }) {
  const [lineId, setLineId] = useState(null);
  const open = useCallback((id) => setLineId(id), []);
  const close = useCallback(() => setLineId(null), []);
  return (
    <DrillCtx.Provider value={{ open }}>
      <OriginScope>
        <div className="space-y-6 animate-fade-in" data-testid="forecast-module">
          <SectionHeader eyebrow={eyebrow || "AI Layer · Forecast / Prediction Models"} title={title} description={description} action={action} />
          <Tabs />
          <OriginSummary />
          {children}
        </div>
      </OriginScope>
      {lineId && <DrillDrawer key={lineId} lineId={lineId} onClose={close} />}
    </DrillCtx.Provider>
  );
}
